'use strict';

function crossfilter_identity(d) {
  return d;
}

module.exports = crossfilter_identity;
